<template>
  <IconsLoader :size="loaderSize" class="app-loader"/>
</template>

<script>
  import {mapGetters} from "vuex";
  import {IconsLoader} from "@/modules/common/components";

  export default {
    name: 'Pending',
    components: {
      IconsLoader
    },
    computed: {
      ...mapGetters(['isMobile']),
      loaderSize() {
        return this.isMobile ? "sm" : "md"
      }
    }
  }
  
</script>

<style lang="scss">
    .app-loader {
      position: fixed;
      z-index: 1;
      top: 0;
    }
</style>
